import { AnimatePresence } from 'framer-motion';
import { memo } from 'react';

import { OutreachModal } from 'components/ui/organisms/OutrachModal';
import { RJCommunicationHub } from 'components/ui/organisms/RJCommunicationHub/RJCommunicationHub';
import { CandidateContextProvider } from 'shared/legacy/contexts/CandidateContext/CandidateContext';
import { CommAgentFlowProvider, useResolveCommAgentFlow } from 'shared/legacy/contexts/CommAgentFlowContext';
import { IndeedCommAgentProvider } from 'shared/legacy/contexts/IndeedCommAgentContext';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { GlobalDialogType } from 'stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialogData } from 'stores/global-dialogs/hooks/useGlobalDialogData';
import { useIsGlobalDialogOpen } from 'stores/global-dialogs/hooks/useIsGlobalDialogOpen';
import { RobinJrStoreProvider } from 'stores/robin-jr/robin-jr.store';
import { OutreachType } from 'types/outreach';
import { useCommitTransactionWhenClosingOutreachDialog } from './hooks/useCommitTransactionWhenClosingOutreachDialog';

export const CandidateOutreachDialog = memo(() => {
  const isVisible = useIsGlobalDialogOpen(GlobalDialogType.CandidateOutreach);

  const { data: currentUser } = useCurrentUserQuery();
  const dialogData = useGlobalDialogData({ isVisible, dialogType: GlobalDialogType.CandidateOutreach });
  const commAgentFlow = useResolveCommAgentFlow(dialogData?.candidate);
  const canUseCommAgent = commAgentFlow !== null;

  useCommitTransactionWhenClosingOutreachDialog();

  if (!dialogData || !currentUser) {
    return null;
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <RobinJrStoreProvider currentUser={currentUser} campaignId={dialogData.candidate.campaignId}>
          {(dialogData.outreachType as OutreachType) === OutreachType.RJCommHub ? (
            canUseCommAgent && (
              <CandidateContextProvider candidate={dialogData.candidate}>
                <CommAgentFlowProvider candidate={dialogData.candidate}>
                  <IndeedCommAgentProvider>
                    <RJCommunicationHub candidate={dialogData.candidate} initialVacancy={dialogData.initialVacancy} />
                  </IndeedCommAgentProvider>
                </CommAgentFlowProvider>
              </CandidateContextProvider>
            )
          ) : (
            <OutreachModal candidate={dialogData.candidate} type={dialogData.outreachType} />
          )}
        </RobinJrStoreProvider>
      )}
    </AnimatePresence>
  );
});
